import React from 'react';
import { Skeleton } from 'antd';
import styled from 'styled-components';

const Wrapper = styled.div`
  border-radius: 8px;
  background: #fff;
  box-shadow: 0px 0px 16.875px -1.40625px rgba(0, 0, 0, 0.08);
  height: 100%;
  width: 100%;
  margin-bottom: 16px;
  margin-top: 24px;
  /* display: flex; */
  .ant-skeleton-element {
    width: 100% !important;
  }
`;
const CreateFormSkeleton: React.FC = () => {
  return (
    <>
      <Wrapper>
        <div style={{ display: 'flex', alignItems: 'center', padding: '24px 16px 0px 16px' }}>
          <div style={{ display: 'flex', width: '15%' }}>
            <Skeleton.Input style={{ width: '130px', height: '24px', borderRadius: '8px' }} active size={'small'} block={true} />
          </div>
          <div style={{ display: 'flex', width: '100%' }}>
            <Skeleton.Input style={{ width: '100%', height: '38px', borderRadius: '8px' }} active size={'small'} block={true} />
          </div>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', padding: '16px' }}>
          <div style={{ display: 'flex', width: '15%' }}>
            <Skeleton.Input style={{ width: '130px', height: '24px', borderRadius: '8px' }} active size={'small'} block={true} />
          </div>
          <div style={{ display: 'flex', width: '100%' }}>
            <Skeleton.Input style={{ width: '100%', height: '38px', borderRadius: '8px' }} active size={'small'} block={true} />
          </div>
        </div>
      </Wrapper>
      <Wrapper>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '24px 16px 24px 16px' }}>
          <div style={{ display: 'flex', width: '15%' }}>
            <Skeleton.Input style={{ width: '130px', height: '24px', borderRadius: '8px' }} active size={'small'} block={true} />
          </div>
          <div style={{ display: 'flex', width: '15%' }}>
            <Skeleton.Input style={{ width: '100%', height: '38px', borderRadius: '8px' }} active size={'small'} block={true} />
          </div>
        </div>
      </Wrapper>
      <Wrapper>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '24px 16px 24px 16px' }}>
          <div style={{ display: 'flex', width: '15%' }}>
            <Skeleton.Input style={{ width: '130px', height: '24px', borderRadius: '8px' }} active size={'small'} block={true} />
          </div>
          <div style={{ display: 'flex', width: '15%' }}>
            <Skeleton.Input style={{ width: '100%', height: '38px', borderRadius: '8px' }} active size={'small'} block={true} />
          </div>
        </div>
      </Wrapper>
    </>
  );
};

export default CreateFormSkeleton;
